import axios from 'axios';
import type { LoginMethodsResponse } from './types/generated';

/**
 * `apiBaseUrl` is the backend root WITHOUT `/v1`. Returns null on any error,
 * never throws.
 */
export async function fetchLoginMethods(apiBaseUrl: string): Promise<LoginMethodsResponse | null> {
  const url = `${apiBaseUrl.replace(/\/$/, '')}/v1/login/methods`;
  try {
    const { data } = await axios.get<LoginMethodsResponse>(url, {
      timeout: 5000,
      withCredentials: false,
    });
    return data;
  } catch (err) {
    console.warn('[login] fetchLoginMethods failed:', err);
    return null;
  }
}
